import ScriptLocation from './script-location.entity';
import {
	SosCreateResponse,
	SosListResponse,
	SosUpdateResponse,
	SosDeleteResponse,
} from '../sos-response';

export interface ScriptLocationListResponse extends SosListResponse {
	listed: {
		ScriptLocation: ScriptLocation[];
	};
}

export interface ScriptLocationCreateResponse extends SosCreateResponse {
	created: {
		ScriptLocation: ScriptLocation[];
	};
}

export interface ScriptLocationUpdateResponse extends SosUpdateResponse {
	updated: {
		ScriptLocations: ScriptLocation[];
	};
}

export interface ScriptLocationDeleteResponse extends SosDeleteResponse {
	destroyed: {
		ScriptLocations: ScriptLocation[];
	};
}
